// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"38fd3313","234":"1b1f5079","628":"da26fef3","735":"65d68714","787":"2d434f7b","863":"aeaf5f3b"}[chunkId] + ".chunk.js";
};